import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ChatusersModalPageRoutingModule } from './chatusers-modal-routing.module';

import { ChatusersModalPage } from './chatusers-modal.page';
import { PipesModule } from '../../pipes/pipes.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ChatusersModalPageRoutingModule,
    PipesModule
  ],
  declarations: [ChatusersModalPage]
})
export class ChatusersModalPageModule {}
